import React from 'react';
import { QRData } from '../../types/qr';
import { HandleInputChangeFunction } from '../QRCodeGenerator';
import { Form, Label, Input, TextArea } from '../styled/FormElements';
import { URLBannerUploadField } from '../URLBannerUploadField';

interface URLQRFormProps {
  qrData: QRData;
  handleInputChange: HandleInputChangeFunction;
  isDynamicQR: boolean;
}

export const URLQRForm: React.FC<URLQRFormProps> = ({ qrData, handleInputChange, isDynamicQR }) => {
  return (
    <Form>
      <Label>
        Action URL:
        <Input
          type="text"
          name="actionUrl"
          value={qrData.url?.actionUrl || ''}
          onChange={(e) => handleInputChange(e, 'url')}
          placeholder="Enter the URL to navigate to"
          required
        />
      </Label>
      
      {isDynamicQR && (
        <>
          <Label>
            Title:
            <Input
              type="text"
              name="title"
              value={qrData.url?.title || ''}
              onChange={(e) => handleInputChange(e, 'url')}
              placeholder="Enter title"
            />
          </Label>
          
          <Label>
            Description:
            <TextArea
              name="description"
              value={qrData.url?.description || ''}
              onChange={(e) => handleInputChange(e, 'url')}
              placeholder="Enter description"
            />
          </Label>
          
          <URLBannerUploadField 
            qrData={qrData} 
            handleInputChange={handleInputChange} 
          />
          
          <Label>
            Button Text:
            <Input
              type="text"
              name="buttonText"
              value={qrData.url?.buttonText || ''}
              onChange={(e) => handleInputChange(e, 'url')}
              placeholder="Enter button text"
            />
          </Label>
          
          <Label>
            Button Color:
            <Input
              type="color"
              name="buttonColor"
              value={qrData.url?.buttonColor || '#ff6320'}
              onChange={(e) => handleInputChange(e, 'url')}
            />
          </Label>
        </>
      )}
    </Form>
  );
};